import { mutator } from 'satcheljs';
import { setShowDialog } from '../actions/emailReminderDialogActions';
import emailRemindersStore from '../store/store';

/**
 * Sets showDialog property in store
 */
mutator(setShowDialog, actionMessage => {
    emailRemindersStore.showDialog = actionMessage.shouldShow;
});
